export const ANNUAL_VALIDATION_HEADER_HEIGHT = 50;
export const DOCUMENT_PROCESSING_HEADER_HEIGHT = 50;
export const DOCUMENT_VALIDATION_HEADER_HEIGHT = 70;
export const KYC_HEADER_HEIGHT = 50;
export const TIMER_HEADER_HEIGHT = 32;
export const HEADER_HEIGHT = 96;
export const IAUI_NOTIFICATION_HEADER_HEIGHT = 45;
export const DEFAULT_BRAND_LOGO_KEY = "general.brand-logo";
export const HIDE_KYC_NOTIFICATION_STORAGE_KEY = "hideKycNotification";
